<div class="flex min-w-0 flex-1 flex-col">
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1 p-6">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [searchPlaceHolder]="'Rechercher par ID événement (ex: evt_...)'"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-stripe-subscription-events-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>
            @switch (column.key) {
              @case ('eventId') {
                <td mat-cell *matCellDef="let event" class="font-mono text-xs">
                  {{ event.eventId }}
                </td>
              }
              @case ('type') {
                <td mat-cell *matCellDef="let event">
                  <aura-simple-chip [text]="event.type" />
                </td>
              }
              @case ('processed') {
                <td mat-cell *matCellDef="let event">
                  <div
                    class="inline-flex items-center gap-x-1.5 rounded-md bg-neutral-a4 px-1.5 py-0.5 text-sm font-medium"
                  >
                    <div
                      class="size-1.5 rounded-full"
                      [class.bg-green-9]="event.processed"
                      [class.bg-red-9]="!event.processed"
                    ></div>
                    {{ event.processed ? 'Oui' : 'Non' }}
                  </div>
                </td>
              }
              @case ('processedAt') {
                <td mat-cell *matCellDef="let event">
                  {{ event.processedAt | luxonDate: 'dd/LL/yyyy HH:mm' }}
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let event">
                  {{ event.createdAt | luxonDate: 'dd/LL/yyyy HH:mm' }}
                </td>
              }
              @case ('error') {
                <td mat-cell *matCellDef="let event" class="text-red-9 max-w-xs truncate">
                  {{ event.error }}
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let event">
                  {{ event[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
